module.exports = __webpack_public_path__ + "static/media/c-sharp-intermediate.425a97d2.png";